let dataObj = "";

function loadData(url) {
	fetch(url)
		.then(function (response) {
			if (!response.ok) {
				throw new Error("Failed to load data: " + response.status);
			}
			return response.json();
		})
		.then(function (jsonData) {
			dataObj = jsonData;
		})
		.catch(function (error) {
			console.error("Request failed:", error.message);
		});
}

export { dataObj, loadData };
